module.exports = __webpack_public_path__ + "static/process_exporting4_1-ea5eafee4a55ad99be64afc605aabb3c.jpg";